import { useCallback } from "react";
import {
  deleteCookie,
  getCookie,
  setCookie,
} from "../helpers/utils/storage.util";

function useAuthenticationToken() {
  const getToken = useCallback(() => getCookie("jwt-token"), []);

  const setToken = useCallback((token: string) => {
    setCookie("jwt-token", token);
  }, []);

  const deleteToken = useCallback(() => {
    deleteCookie("jwt-token");
  }, []);

  return {
    getToken,
    setToken,
    deleteToken,
  };
}

export default useAuthenticationToken;
